// Formato amigável (5m20s, 5h10m, 45s) — diferente do formatDuration
// compartilhado (mm:ss/hh:mm:ss), que aqui ficava com muita casa decimal
// por causa de valores float vindos do backend (ex: avg_resolution_time).
export const formatFriendlyDuration = seconds => {
  const totalSeconds = Math.round(Number(seconds) || 0);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  if (hours > 0) return `${hours}h${minutes}m`;
  if (minutes > 0) return `${minutes}m${secs}s`;
  return `${secs}s`;
};
